export default "__VITE_ASSET__CUzRTz2Z__"